import React from 'react';
import { TooltipRenderProps } from 'react-joyride';

const CustomTooltip: React.FC<TooltipRenderProps> = ({
  step,
  index,
  size,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps
}) => {
  return (
    <div
      {...tooltipProps}
      style={{
        padding: '1rem',
        backgroundColor: '#222',
        color: '#fff',
        borderRadius: 8,
        maxWidth: 300,
      }}
    >
      <div>
        {step.title && <h4 style={{ marginBottom: '0.5rem' }}>{step.title}</h4>}
        <p>{step.content}</p>
      </div>

      {/* Step indicator */}
      <div style={{ fontSize: '0.85rem', margin: '0.5rem 0' }}>
        Step {step.data?.stepNumber ?? index + 1} of {step.data?.totalSteps ?? size}
      </div>

      {/* Navigation buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
        {/* <button {...skipProps} style={buttonStyle}>Skip</button> */}
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {index > 0 && <button {...backProps} style={buttonStyle}>Back</button>}
          <button {...primaryProps} style={buttonStyle}>
            {index + 1 === size ? 'Finish' : 'Next'}
          </button>
        </div>
      </div>

      {/* Close button */}
      {/* <button {...closeProps} style={{ ...buttonStyle, marginTop: '0.5rem', float: 'right' }}>
        ✕
      </button> */}
    </div>
  );
};

const buttonStyle: React.CSSProperties = {
  padding: '0.4rem 0.8rem',
  backgroundColor: '#39931d',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: '0.9rem',
};

export default CustomTooltip;
